import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import {
  IChatDraftMessage,
  IConversationMediaPolicy,
  LastMessageIndexRequest,
  TwilioMessage,
  ITwilioMessageResponse,
} from '@nimbus-global/features/chat/models/chat-twilio.model';
import { ChatSendMessageRequest } from '@nimbus-global/features/chat/models/chat-service.model';

@Injectable({
  providedIn: 'root',
})
export class ChatTwilioApiClient {
  public constructor(private readonly httpService: BaseHttpService) {}

  public sendMessage(apiUrl: string, request: ChatSendMessageRequest): Observable<TwilioMessage> {
    return this.httpService.post(apiUrl, request);
  }

  public sendMedia(apiUrl: string, file: File): Observable<TwilioMessage> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpService.postFormData<TwilioMessage>(apiUrl, formData);
  }

  public receiveMessages(apiUrl: string): Observable<ITwilioMessageResponse> {
    return this.httpService.get(apiUrl);
  }

  public markMessagesAsRead(apiUrl: string, request: LastMessageIndexRequest): Observable<void> {
    return this.httpService.put(apiUrl, request);
  }

  public saveDraft(apiUrl: string, draft: IChatDraftMessage): Observable<void> {
    return this.httpService.post(apiUrl, draft);
  }

  public getMediaPolicy(apiUrl: string): Observable<IConversationMediaPolicy> {
    return this.httpService.get(apiUrl);
  }
}
